import { DrawerDialog } from '@/common/components/drawer-dialog';
import React from 'react';
import Spacer from '@/common/components/spacer';
import InvoiceLineItemTitleTrigger from '@/checkout/components/invoice-line-item-title-trigger';

interface NewVehicleInfoDialogProps {
  variant?: 'default' | 'trigger';
  open?: boolean;
  handleClose?: () => void;
  title?: string;
  trigger?: React.ReactNode;
}

const newVehicleDialogData = [
  {
    title: 'Key Features:',
    items: [
      "First Driver: You're the first Flexcar member to drive this vehicle.",
      'Current Model Year: Latest features and tech are included.',
      '0-1,000 Miles: Minimal mileage based on initial transport logistics.',
    ],
  },
  {
    title: "What's in it for You:",
    items: [
      'Exclusive Experience: Enjoy the newest additions to our fleet.',
      'Optimal Condition: Vehicle is in pristine condition, mechanically and aesthetically.',
      'Latest Features: Benefit from the latest technology and safety enhancements.',
    ],
  },
];

export default function NewVehicleInfoDialog({
  trigger,
  variant,
  open,
  handleClose,
  title,
}: NewVehicleInfoDialogProps) {
  return variant === 'trigger' ? (
    <DrawerDialog
      trigger={<InvoiceLineItemTitleTrigger title={title || 'New vehicle surcharge'} />}
      title="What does 'new' mean?"
    >
      {newVehicleDialogData.map((data, index) => (
        <React.Fragment key={`main-${index}`}>
          <p className="body-strong">{data.title}</p>
          <Spacer variant="height4" />
          <ul className="ml-5">
            {data.items.map((item, index) => (
              <li key={`item-${index}`}>{item}</li>
            ))}
          </ul>
          {index !== newVehicleDialogData.length - 1 && <Spacer variant="height16" />}
        </React.Fragment>
      ))}
    </DrawerDialog>
  ) : open !== undefined && handleClose !== undefined ? (
    <DrawerDialog open={open} handleClose={handleClose} title="What does 'new' mean?">
      {newVehicleDialogData.map((data, index) => (
        <React.Fragment key={`main-${index}`}>
          <p className="body-strong">{data.title}</p>
          <Spacer variant="height4" />
          <ul className="ml-5">
            {data.items.map((item, index) => (
              <li key={`item-${index}`}>{item}</li>
            ))}
          </ul>
          {index !== newVehicleDialogData.length - 1 && <Spacer variant="height16" />}
        </React.Fragment>
      ))}
    </DrawerDialog>
  ) : (
    <DrawerDialog trigger={trigger} title="What does 'new' mean?">
      {newVehicleDialogData.map((data, index) => (
        <React.Fragment key={`main-${index}`}>
          <p className="body-strong">{data.title}</p>
          <Spacer variant="height4" />
          <ul className="ml-5">
            {data.items.map((item, index) => (
              <li key={`item-${index}`}>{item}</li>
            ))}
          </ul>
          {index !== newVehicleDialogData.length - 1 && <Spacer variant="height16" />}
        </React.Fragment>
      ))}
    </DrawerDialog>
  );
}
